import { memo } from "react";

import { ProductProvider } from "@react/sections/Product/ProductProvider";

import { ProductHero } from "./ProductHeroBase";

const ProductHeroRootBase = () => {
  return (
    <ProductProvider>
      <ProductHero />
    </ProductProvider>
  );
};

export const ProductHeroRoot = memo(ProductHeroRootBase);
